<template>
  <div>
    <div class="section-title">
      <h3>
        {{ estrangeiro ? "Origin Address" : "Endereço" }}
      </h3>
    </div>

    <component
      :is="estrangeiro ? 'EnderecoEstrangeiro' : 'EnderecoNacional'"
      :value="value"
      :paises="paises"
      @validate-field="$emit('validate-field', $event)"
    />
  </div>
</template>

<script>
import EnderecoNacional from "./EnderecoNacional";
import EnderecoEstrangeiro from "./EnderecoEstrangeiro";

export default {
  name: "EnderecoForm",
  components: {
    EnderecoNacional,
    EnderecoEstrangeiro
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    estrangeiro: {
      type: Boolean,
      default: false
    },
    paises: {
      type: Array,
      default: () => []
    }
  },
  emits: ["validate-field"]
};
</script>

<style scoped>
.section-title h3 {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
  color: #295661;
}

@media (max-width: 767px) {
  .section-title h3 {
    font-size: 1rem;
    margin-top: 20px;
  }
}
</style>
